<template>
  <modal
    name="fontpayment-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeFontpaymentDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>

    <!--ポップアップ-->
    <div class="setting" v-if="permissionType == 1">
      <div
        class="setting-item"
        style="text-align: center; border-top: none; padding-top: 0"
      >
        <p style="font-size: 1rem; font-weight: bold">
          ＼220円で全てのフォントが使えます！／
        </p>
        <div
          style="
            display: flex;
            min-width: 100%;
            justify-content: center;
            align-items: center;
            padding: 5px 15px 15px;
          "
        >
          <p style="line-height: 1.2; font-size: 1rem">
            フォントサービス<br />まるごとパック
          </p>
          <p style="font-size: 1rem; font-weight: bold">
            ：220円<span style="font-size: 0.8rem">（税込）</span>
          </p>
        </div>
        <h2>カードで決済</h2>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <stripe-element-card
            ref="stripeCardElememt"
            :pk="publishableKey"
            :hidePostalCode="true"
            @token="tokenCreated"
          />
        </div>
        <h2>PayPayで決済</h2>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <a id="paypay-font-mail-btn" @click="getPayPayCode()"
            ><img
              src="/static/renew2_img/paypay_payment_lg.png"
              style="width: 300px"
          /></a>
          <br />
        </div>
        <br />
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0">
          <li>
            ※Yagishの<router-link
              id="footer-link-terms"
              :to="{ name: 'termsPage' }"
              target="_blank"
              style="color: #004d40; border-bottom: 1px solid #004d40"
              >利用規約</router-link
            >、<router-link
              id="footer-link-policy"
              :to="{ name: 'policyPage' }"
              target="_blank"
              style="color: #004d40; border-bottom: 1px solid #004d40"
              >個人情報保護方針</router-link
            >をご確認ください。
          </li>
          <li>※フォントの購入はPayPay決済とクレジットカード決済が可能です。</li>
          <li>※退会後はフォントの利用ができなくなるのでご注意ください。</li>
          <li>
            ※フォント購入についての説明は<a
              href="/fontservicehelp"
              target="_blank"
              >こちら</a
            >をご確認ください。
          </li>
        </ul>
      </div>
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 1rem; font-weight: bold">
          <img
            src="/static/renew_img/check_icon.png"
            style="width: 30px"
          />上記規約に同意して、<br />フォントサービスを購入して利用開始
        </p>
      </div>
      <div class="text-center" style="padding: 10px">
        <el-button
          id="send-adtop-pdf"
          type="success"
          v-if="isFontpaymentSended == false"
          style="
            background-color: #f60b26;
            border-color: #f60b26;
            font-size: 140%;
          "
          @click="$eventHub.$emit('payment-fontservice')"
          >購入する</el-button
        >
        <el-button
          id="send-adtop-pdf"
          type="success"
          v-if="isFontpaymentSended == true"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="closeFontpaymentDialog()"
          >購入しました</el-button
        >
        <br />
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 22">
      <div class="setting-item" style="text-align: center">
        <p style="font-size: 150%">フォントサービス購入</p>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <p style="font-size: 140%">購入金額：220円（税込）</p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <stripe-element-card
            ref="stripeCardElememt"
            :pk="publishableKey"
            :hidePostalCode="true"
            @token="tokenCreated"
          />
        </div>
        <p>
          Yagishの<router-link
            id="footer-link-terms"
            :to="{ name: 'termsPage' }"
            target="_blank"
            >利用規約</router-link
          >、<router-link
            id="footer-link-policy"
            :to="{ name: 'policyPage' }"
            target="_blank"
            >個人情報保護方針</router-link
          >、<a href="https://www.yagish.jp/privacy_policy/" target="_blank"
            >プライバシーポリシー</a
          ><br />
        </p>
      </div>
      <p style="font-size: 80%">
        ※退会すると購入履歴がなくなりフォントの利用ができなくなるのでご注意ください
      </p>
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          <img
            src="/static/renew_img/check_icon.png"
            style="width: 40px"
          />上記規約に同意して、フォントサービスを購入する
        </p>
      </div>
      <div class="text-center" style="padding: 10px">
        <el-button
          id="send-adtop-pdf"
          type="success"
          v-if="isFontpaymentSended == false"
          style="
            background-color: #f60b26;
            border-color: #f60b26;
            font-size: 140%;
          "
          @click="$eventHub.$emit('payment-fontservice')"
          >購入する</el-button
        >
        <el-button
          id="send-adtop-pdf"
          type="success"
          v-if="isFontpaymentSended == true"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="closeFontpaymentDialog()"
          >送信しました</el-button
        >
        <br />
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align: center">
        <p style="font-size: 150%">フォントサービス購入完了</p>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          <p style="font-size: 140%">購入金額：220円（税込）</p>
        </div>
        <div style="display: inline-block; min-width: 100%; text-align: center">
          購入が完了されました。続けてフォントサービスをご利用ください。
        </div>
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0">
          <li>
            ※フォントの切り替え方法については<a
              href="/fontservicehelp"
              target="_blank"
              >こちら</a
            >をご確認ください。
          </li>
        </ul>
      </div>
    </div>
    <div class="text-right">
      <el-button @click="closeFontpaymentDialog">閉じる</el-button>
    </div>
    <modal
      name="open_paypay_modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
    >
      <div class="v--modal-close-top">
        <el-button
          @click="$modal.hide('open_paypay_modal')"
          icon="el-icon-close"
          type="text"
        ></el-button>
      </div>
      <div class="title" style="text-align: center; color: rgb(231, 54, 0)">
        決済しただけでは注文は完了しません
      </div>
      <br />
      <span
        >注文を完了するにはPayPay決済画面のご利用中のサービスに戻るボタンを押下してください。</span
      >
      <div style="width: 100%">
        <img
          src="/static/renew2_img/paypay_alert_image_20240214.png"
          style="width: 100%"
        />
      </div>
      <div class="text-center">
        <el-button
          type="primary"
          style="width: 100%; height: 70px"
          @click="openPayPaySite"
          >注意事項を理解し、決済サービスを開く</el-button
        >
      </div>
    </modal>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe'

export default {
  components: {
    StripeElementCard
  },
  data: function () {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isFontpaymentSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      paypayurl: '',
      merchant_payment_id: '',
      isAgree: false
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(
      function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      },
      function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      }
    )
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openFontpaymentDialog: function (id) {
      this.formatid = id
      this.$modal.show('fontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'fontpayment_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {
        timeout: 60000
      })
      this.$iterateStorage(
        function (value, key, iterationNumber) {
          // console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
        },
        function (err) {
          if (!err) {
            console.log('Iteration has completed')
          }
        }
      )
    },
    complatePayPay: function (merchant_payment_id) {
      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('merchant_payment_id', merchant_payment_id)
      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('site_flag', 'r')
      formData.append('version', '3')
      this.$axios
        .post(this.$varuna.endPoints.paypayComplateFont, formData, {
          timeout: 60000
        })
        .then(async function (response) {
          if (response.data.status == 'success') {
            // if (response['data']['data']['status'] == 'COMPLETED') {
            app.$message({
              duration: 0,
              message: '支払確認ができました。購入処理を完了します',
              type: 'success'
            })
            app.fullscreenLoading = false
            app.permissionType = 2
          } else {
            app.$message({
              duration: 0,
              message: '取得失敗しました。エラーコード：EQ1001',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error)
          app.$message({
            message: '取得失敗しました。',
            type: 'error'
          })
        })
        .finally(function () {
          // app.goCardTo('payment')
          app.fullscreenLoading = false
        })
    },
    openPayPaySite: function () {
      const app = this
      // app.$eventHub.$emit('email_loading_on')
      app.fullscreenLoading = true
      app.complatePayPay(app.merchant_payment_id)
      // app.$eventHub.$emit('complate_paypay', app.merchant_payment_id)
      location.href = this.paypayurl
    },
    getPayPayCode: function () {
      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('version', '3')
      this.$axios
        .post(this.$varuna.endPoints.getPaypaycodeFont, formData, {
          timeout: 60000
        })
        .then(async function (response) {
          console.error(response.data.status)
          if (response.data.status == 'success') {
            console.error(response.data)
            app.$modal.show('open_paypay_modal')
            app.$message({
              message: 'PayPayページに遷移してください',
              type: 'success'
            })
            // location.href=url
            app.paypayurl = response.data.data.url
            app.merchant_payment_id = response.data.data.merchantPaymentId
          } else {
            app.$message({
              message: '取得失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error)
          app.$message({
            message: '取得中に問題が発生しました',
            type: 'error'
          })
        })
        .finally(function () {})
    },
    tokenCreated(token) {
      const app = this
      app.$eventHub.$emit('email_loading_on')
      this.token = token.id
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      this.fullscreenLoading = true
      this.$axios
        .post(this.$varuna.endPoints.paymentFont, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.data.status == 'success') {
            app.permissionType = 2
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            app.fullscreenLoading = false
            app.$eventHub.$emit('get_fontpayment')
          } else {
            app.fullscreenLoading = false
            app.$message({
              message: '決済失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          app.fullscreenLoading = false
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    closeFontpaymentDialog: function () {
      this.$modal.hide('fontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendFontpayment: async function () {
      this.$refs.stripeCardElememt.submit()
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('payment-fontservice', this.sendFontpayment)
    this.$eventHub.$on('popstate', this.closeFontpaymentDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('payment-fontservice', this.sendFontpayment)
    this.$eventHub.$off('popstate', this.closeFontpaymentDialog)
  }
}
</script>
